import React, { useState, useEffect } from "react";

const portfolio = [
  {
    title: "Fymapp",
    description: "Plataforma de gestión de inventario",
    image: "https://fymappsoftware.com/logo-letters.png",
    tech: ["React", "Node.js", "MongoDB"],
    link: "https://fymappsoftware.online/",
  },
  {
    title: "DeportivosPro",
    description: "Sistema de consejos deportivos",
    image:
      "https://firebasestorage.googleapis.com/v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Ficon512x512preview.png?alt=media&token=00445cc5-773d-43aa-862e-6c437b48bce2",
    tech: ["Python", "PostgreSQL", "Docker"],
    link: "https://deportivospro.online/",
  },
  {
    title: "Crea y viste",
    description: "Aplicación móvil para crear y diseñar ropa",
    image:
      "https://firebasestorage.googleapis.com/v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Fcrea%20y%20viste%20logo.jpg?alt=media&token=2fd85ce1-1e30-4a4c-b340-4000aed76463",
    tech: ["React Native", "Firebase", "Google Maps"],
    link: "https://crea-y-viste.web.app/",
  },
  {
    title: "La MakyStore",
    description: "Tienda de ropa con sentido social",
    image:
      "https://m.media-amazon.com/images/I/71KDbo5z9PL._AC_UF894,1000_QL80_.jpg",
    tech: ["WordPress", "PayU", "PostgreSQL"],
    link: "https://lamakystore.shop/",
  },
  {
    title: "Econo Tacna",
    description: "Tienda, Bebidas, Alimentos etc.",
    image: "https://econotacna.com/wp-content/uploads/2024/11/Logo.jpg",
    tech: ["WordPress", "PHP", "SQL"],
    link: "https://econotacna.com/",
  },
];

export default function Portfolio() {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    const section = document.getElementById("portfolio");
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <section
      id="portfolio"
      className="py-24 bg-gradient-to-b from-black to-gray-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div
          className={`text-center mb-16 transform transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent mb-6">
            Nuestro Portafolio
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">
            Explora nuestra colección de proyectos innovadores y soluciones
            tecnológicas
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolio.map((project, index) => (
            <div
              key={index}
              className={`transform transition-all duration-500 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block group relative rounded-2xl overflow-hidden bg-gray-800 hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300"
              >
                {/* Image Container */}
                <div className="relative h-64 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" />
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
                  />
                  {/* Overlay on Hover */}
                  <div
                    className={`absolute inset-0 bg-black/40 transition-opacity duration-300 ${
                      hoveredIndex === index ? "opacity-100" : "opacity-0"
                    }`}
                  />
                </div>

                {/* Content Container */}
                <div className="relative z-20 p-6 -mt-20">
                  <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-gray-300 mb-4">{project.description}</p>
                  {/* Tech Stack */}
                  <div className="flex flex-wrap gap-2">
                    {project.tech.map((tech, techIndex) => (
                      <span
                        key={techIndex}
                        className="px-3 py-1 text-sm rounded-full bg-yellow-500/10 text-yellow-400 border border-yellow-500/20"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                  {/* View Project Button */}
                  <div
                    className={`mt-4 transform transition-all duration-300 ${
                      hoveredIndex === index
                        ? "translate-y-0 opacity-100"
                        : "translate-y-4 opacity-0"
                    }`}
                  >
                    <span className="inline-flex items-center text-yellow-400 hover:text-yellow-300">
                      Ver Proyecto
                      <svg
                        className="w-4 h-4 ml-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
